import { Box, Typography } from "@mui/material";

interface MAreaCardProps {
  bgImg: string;
  title: string;
  storeNum: number;
}
function MAreaCard({ bgImg, title, storeNum }: MAreaCardProps) {
  return (
    <Box
      position="relative"
      width="120px"
      height="120px"
      boxSizing="border-box"
      borderRadius={2}
    >
      <Box
        width="100%"
        height="100%"
        borderRadius={2}
        component="img"
        src={bgImg ?? "/image-holder.png"}
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        height="100%"
        width="100%"
        boxSizing="border-box"
        borderRadius={2}
        display="flex"
        alignContent="center"
        justifyContent="center"
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <Box
          position="absolute"
          top="50%"
          padding="0 4%"
          width="100%"
          boxSizing="border-box"
          textAlign="center"
          sx={{
            transform: "translateY(-40%)",
          }}
        >
          <Typography variant="h5" fontWeight="bold" color="white">
            {title}
          </Typography>
          <Typography fontWeight="bold" color="white">
            {storeNum.toLocaleString()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default MAreaCard;
